<script setup lang="ts">
import { onMounted,onBeforeUnmount,ref,reactive,computed } from 'vue'
import config from "../../config.js";
import { successAlert,errorAlert,confirmAlert } from "../../plugins/alert";
import qs from 'qs';
import axios from '../../plugins/axios.ts';
import { useOrderStore } from '../../stores/order';
import { useStockStore } from '../../stores/stock';
import { useEstimateStore } from '../../stores/estimate';
import { useHeadEstimateStore } from '../../stores/head_estimate';

const order = useOrderStore();
const stock = useStockStore();
const estimate = useEstimateStore();
const head_estimate = useHeadEstimateStore();

const props = defineProps({
    sideMenus:{
      type:Array,
      required:true,
    },
    path:{
      type:String,
      required:true,
    },
    alert:{
      type:Object,
      required:true,
    },
    isInitialized:{
      type:Boolean,
      required:true,
    },
})

const asideRef = ref();
const expandList = reactive([]);
for (let i=0;i<props.sideMenus.length;i++) {
  if (typeof props.sideMenus[i].side_menus !== 'undefined') {
    let isExpand = false;
    for (let j=0;j<props.sideMenus[i].side_menus.length;j++) {
      if (('/' + props.sideMenus[i].side_menus[j].path + '/') == props.path) {
        isExpand = true;
        break;
      }
    }
    expandList.push({
      key:props.sideMenus[i].key,
      is_expand:isExpand,
    });
  }
}
onMounted(() => {
  asideRef.value.style.top = String(document.getElementById('header').getBoundingClientRect().height) + 'px';
});

const initializedAlert = (path) => {
  if (props.isInitialized) {
    return;
  }
  if (checkInitilizedSetting(path)) {
    return;
  }
  errorAlert("採用品と開設許可証をご登録ください。");
}
const clickExpand = (key) => {
  for (let i=0;i<expandList.length;i++) {
    if (expandList[i].key == key) {
      expandList[i].is_expand = !expandList[i].is_expand;
    }
  }
}
const isExpandKey = computed((key) => {
  return (key) => {
    let result = false;
    for (let i=0;i<expandList.length;i++) {
      if (expandList[i].key == key) {
        result = expandList[i].is_expand;
        break;
      }
    }
    return result;
  }
})
const checkInitilizedSetting = (path) => {
  let result = false;
  if (path == 'setting/pharmacy-medicine' || path == 'setting/wholesaler') {
    result = true;
  }
  return result;
}
const isInitializedSetting = computed(() => {
  return (path) => {
    return checkInitilizedSetting(path);
  }
})
</script>

<style scoped>
</style>
<template>
<aside ref="asideRef" class="sticky left-0 hidden z-40 main-h lg:flex flex-shrink-0 flex-col w-48 transition-width duration-75" id="aside_bar">
  <div class="relative flex-1 flex flex-col min-h-0 border-r border-gray-200 bg-white pt-0">
    <div class="flex-1 flex flex-col pb-4 overflow-y-auto">
      <div class="flex-1 px-3 bg-white divide-y space-y-1">
        <ul class="space-y-2 pb-2">
          <li v-for="side_menu in sideMenus" :key="side_menu.key">
            <button v-show="(typeof side_menu.side_menus !== 'undefined')" type="button" @click="clickExpand(side_menu.key)" class="relative text-base text-gray-900 font-normal rounded-lg flex items-center p-2 group hover:bg-gray-100 transition duration-75 w-full">
              <img class="w-6 h-6" :src="side_menu.icon" :alt="side_menu.icon_alt">
              <span class="ml-3 flex-1 text-left whitespace-nowrap" sidebar-toggle-item>{{ side_menu.name }}</span>
              <span v-show="side_menu.key == 'setting' && estimate.is_edited()" class="inline-flex absolute right-8 justify-center items-center w-6 h-6 text-xs font-bold text-white bg-amber-500 rounded-full border-2 border-white dark:border-gray-900"><i class="fa-regular fa-pen-to-square"></i></span>
              <span v-show="side_menu.key == 'head' && head_estimate.is_edited()" class="inline-flex absolute right-8 justify-center items-center w-6 h-6 text-xs font-bold text-white bg-amber-500 rounded-full border-2 border-white dark:border-gray-900"><i class="fa-regular fa-pen-to-square"></i></span>
              <span v-show="side_menu.key == 'setting' && alert.alert_settings" class="inline-flex absolute right-3 justify-center items-center w-6 h-6 text-xs font-bold text-white bg-red-700 rounded-full border-2 border-white dark:border-gray-900"><i class="fa-solid fa-triangle-exclamation"></i></span>
              <svg  fill="currentColor" class="w-6 h-6" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd"></path></svg>
            </button>
            <ul v-show="(typeof side_menu.side_menus !== 'undefined') && isExpandKey(side_menu.key)" class="space-y-2 py-2">
              <a v-for="side_sub in side_menu.side_menus" @click="initializedAlert(side_sub.path)" :href="(isInitialized || isInitializedSetting(side_sub.path) ? '/' + side_sub.path : 'javascript:void(0)')" :class="'relative text-base font-normal rounded-lg flex items-center p-2 group hover:bg-gray-400 transition duration-75 pl-11 ' + (('/' + side_sub.path + (side_sub.path.length > 0 ? '/' : '')) == path ? 'bg-gray-400 text-white' : 'text-gray-900')">
              <span v-show="isInitialized == false && isInitializedSetting(side_sub.path) == false" class="text-lg"><i class="fa-solid fa-key"></i></span>
              {{ side_sub.name }}
              <span v-show="side_sub.path == 'setting/pharmacy-medicine' && alert.alert_wholesaler" class="inline-flex absolute right-1 justify-center items-center w-6 h-6 text-xs font-bold text-white bg-red-700 rounded-full border-2 border-white dark:border-gray-900"><i class="fa-solid fa-triangle-exclamation"></i></span>
              <span v-show="side_sub.path == 'setting/estimate' && estimate.is_edited()" class="inline-flex absolute right-2 justify-center items-center w-6 h-6 text-xs font-bold text-white bg-amber-500 rounded-full border-2 border-white dark:border-gray-900"><i class="fa-regular fa-pen-to-square"></i></span>
              <span v-show="side_sub.path == 'head/estimate' && head_estimate.is_edited()" class="inline-flex absolute right-2 justify-center items-center w-6 h-6 text-xs font-bold text-white bg-amber-500 rounded-full border-2 border-white dark:border-gray-900"><i class="fa-regular fa-pen-to-square"></i></span>
              </a>
            </ul>
            <a v-show="(typeof side_menu.side_menus === 'undefined')" @click="initializedAlert(side_menu.path)" :href="(isInitialized ? '/' + side_menu.path : 'javascript:void(0)')" :class="'text-base font-normal rounded-lg flex items-center p-2 hover:bg-gray-400 group ' + (('/' + side_menu.path + (side_menu.path.length > 0 ? '/' : '')) == path ? 'bg-gray-400 text-white' : 'text-gray-900')">
                <img class="w-6 h-6" :src="side_menu.icon" :alt="side_menu.icon_alt">
                <span v-show="isInitialized == false" class="text-lg"><i class="fa-solid fa-key"></i></span>
                <span class="ml-3" sidebar-toggle-item>{{ side_menu.name }}</span>
                <span v-show="side_menu.path == 'order' && order.get_editing_ids().length > 0" class="inline-flex absolute right-2 justify-center items-center w-6 h-6 text-xs font-bold text-white bg-amber-500 rounded-full border-2 border-white dark:border-gray-900"><i class="fa-regular fa-pen-to-square"></i></span>
                <span v-show="side_menu.path == 'stock' && stock.get_editing_ids().length > 0" class="inline-flex absolute right-2 justify-center items-center w-6 h-6 text-xs font-bold text-white bg-amber-500 rounded-full border-2 border-white dark:border-gray-900"><i class="fa-regular fa-pen-to-square"></i></span>
            </a>
          </li>
        </ul>
        <div class="space-y-2 pt-2">
        </div>
      </div>
    </div>
  </div>
</aside>
<div class="bg-gray-900 opacity-50 hidden fixed inset-0 z-10"></div>
</template>

